import { StoryblokServerComponent, storyblokEditable } from '@storyblok/react/rsc'
import Typography from '@audioeye-marketing/ui/src/components/Typography'
import Stack from '@audioeye-marketing/ui/src/components/Stack'

const Signature = ({ blok, backgroundColor }) => {
  return (
    <Stack
      {...storyblokEditable(blok)}
      spacing={4}
      direction="row"
      sx={{ marginTop: '24px !important' }}
      className="ItemSignature"
    >
      {blok?.image?.map((currentImage) => (
        <StoryblokServerComponent key={currentImage?._uid} blok={currentImage} maxWidth={82} />
      ))}
      <Stack spacing={2}>
        {Boolean(blok?.name) && <Typography displaySmall>{blok?.name}</Typography>}

        {blok?.text?.map((currentText) => (
          <StoryblokServerComponent key={blok?._uid} blok={currentText} backgroundColor={backgroundColor} />
        ))}
      </Stack>
    </Stack>
  )
}

export default Signature
